/**
 * Где встать панели выделения (`components/ielts/SelectionToolbar.tsx`), 27.10.2026, сборка 1.1.2.
 *
 * Мышь — над выделением, как было. Палец — ПОД выделением: над ним iOS и Android сами рисуют своё меню
 * («Скопировать / Найти»), убрать его из страницы нельзя, и наша панель легла бы под него. По ширине панель не
 * вылезает за край экрана: выделение у края на 390 иначе уводило бы половину кнопок за экран.
 */
export type BarPlace = { left: number; top: number; below: boolean };

/** Половина ширины панели (4 кнопки по 36 + отступы) и поле до края экрана. */
export const BAR_HALF = 80;
export const EDGE = 8;

export function placeBar(
  rect: { left: number; width: number; top: number; bottom: number },
  viewportWidth: number,
  touch: boolean,
): BarPlace {
  const centre = rect.left + rect.width / 2;
  const min = BAR_HALF + EDGE;
  const max = Math.max(min, viewportWidth - BAR_HALF - EDGE);
  const left = Math.min(max, Math.max(min, centre));
  return touch ? { left, top: rect.bottom + EDGE, below: true } : { left, top: rect.top - EDGE, below: false };
}
